import { Delete, Get, Patch, Post } from "./apiHelper";
import { ICtc, ICtcFormData, ICtcSummary } from "../interfaces/CtcInterface";
import { ApiResponse } from "../interfaces/Api";

const ctcRoot = "/api/ctcs";

// POST /ctcs
export const postCtc = async (data: ICtcFormData): Promise<ApiResponse<ICtc>> => {
  const response = await Post(`${ctcRoot}`, data as unknown as Record<string, unknown>, true);
  return response.data as ApiResponse<ICtc>;
};

// PATCH /ctc/:id
export const patchCtc = async ({
  id,
  data
}: {
  id: number | string;
  data: ICtcFormData;
}): Promise<ApiResponse<ICtc>> => {
  const response = await Patch(
    `${ctcRoot}/${id}`,
    data as unknown as Record<string, unknown>,
    true
  );
  return response.data as ApiResponse<ICtc>;
};

// GET /ctcs
export const getCtcs = async ({
  employeeIds,
  serviceProviderIds
}: {
  employeeIds?: number[];
  serviceProviderIds?: number[];
}): Promise<ApiResponse<ICtc[]>> => {
  const queryParams = new URLSearchParams();
  if (employeeIds?.length) {
    queryParams.append("employeeIds", employeeIds.join(","));
  }

  if (serviceProviderIds?.length) {
    queryParams.append("serviceProviderIds", serviceProviderIds.join(","));
  }

  const response = await Get(`${ctcRoot}?${queryParams.toString()}`, true);
  return response.data as ApiResponse<ICtc[]>;
};

// GET /ctcs/:id
export const getCtc = async (id: number | string): Promise<ApiResponse<ICtc>> => {
  const response = await Get(`${ctcRoot}/${id}`, true, {});
  return response.data as ApiResponse<ICtc>;
};

// DELETE /ctcs/:id
export const deleteCtc = async (id: number | string): Promise<ApiResponse<null>> => {
  const response = await Delete(`${ctcRoot}/${id}`, true, {});
  return response.data as ApiResponse<null>;
};

// POST /ctcs/calculate
export const calculateCtcSummary = async (
  data: Partial<ICtc>
): Promise<ApiResponse<ICtcSummary>> => {
  const response = await Post(
    `${ctcRoot}/calculate`,
    data as unknown as Record<string, unknown>,
    true
  );
  return response.data as ApiResponse<ICtcSummary>;
};
